import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '@cart/const';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { SelectedPrice } from '@product/const';
import { SelectedPriceService } from '@product/data-access';
import { CartModification, ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { filter, mergeMap, take } from 'rxjs/operators';
import { CART_MODIFICATION_NORMALIZER } from '../converters';

@Injectable({
  providedIn: 'root',
})
export class CartEntryApiService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService,
    private selectedPriceService: SelectedPriceService,
  ) {}

  add(
    cartId: string,
    productCode: string,
    quantity: number = 1,
    selectedPrice?: SelectedPrice,
  ): Observable<CartModification> {
    const toAdd = JSON.stringify({});
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const price$ = selectedPrice
      ? of(selectedPrice)
      : this.selectedPriceService.getSelectedPrice(productCode).pipe(filter<SelectedPrice>(Boolean), take(1));

    return price$.pipe(
      mergeMap((price: SelectedPrice) => {
        const url = this.occEndpointsService.buildUrl(API_ENDPOINTS.addEntries, {
          urlParams: { cartId },
          queryParams: {
            code: productCode,
            qty: quantity,
            unit: price.unit?.code,
            isTransit: false,
          },
        });

        return this.http
          .post<CartModification>(url, toAdd, {
            headers,
            context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, API_ENDPOINTS.addEntries),
          })
          .pipe(this.converterService.pipeable(CART_MODIFICATION_NORMALIZER));
      }),
    );
  }

  update(cartId: string, entryNumber: string, qty: number, pickupStore?: string): Observable<CartModification> {
    let params = {};
    if (pickupStore) {
      params = {
        deliveryPointOfService: {
          name: pickupStore,
        },
      };
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const url = this.occEndpointsService.buildUrl(API_ENDPOINTS.updateEntries, {
      urlParams: {
        cartId,
        entryNumber,
      },
    });

    return this.http
      .patch<CartModification>(url, { quantity: qty, ...params }, { headers })
      .pipe(this.converterService.pipeable(CART_MODIFICATION_NORMALIZER));
  }

  remove(cartId: string, entryNumber: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const url = this.occEndpointsService.buildUrl(API_ENDPOINTS.removeEntries, {
      urlParams: {
        cartId,
        entryNumber,
      },
    });

    return this.http.delete(url, { headers });
  }
}
